// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../.config/yarn/global/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".notepad[data-v-4ec44dc5]{background-color:#fff2cc;border-radius:5px;width:100%;height:125px}.card-body[data-v-4ec44dc5]{overflow-y:auto}", ""]);
// Exports
module.exports = exports;
